export class RequestLineModel {
  id: number;
  request_header_id: number;
  line_no: number;
  request_type: string;
  request_type_id: number;
  request_type_name: string;
  request_type_description: string;
  type: string;
  no: number;
  name: string;
  description: string;
  menu_section_id: number;
  menu_section_name: string;
  menu_category_id: number;
  menu_category_name: string;
  menu_item_id: number;
  menu_item_name: string;
  quantity: number;
  unit_price: number;
  currency_code: string;
  amount: number;
  request_time: string;
  unit_of_measure: string;
  child_ages: string;
  date: string;
  note: string;
  gift_expire_date: Date;
  create_voucher_no: boolean;
  voucher_no: string;
  is_redeemed: boolean;
  redeemed_user_id: number;
  redeemed_at: Date;


  constructor(
    id = 0,
    request_header_id = 0,
    line_no = 0,
    request_type = '',
    request_type_id = 0,
    request_type_name = '',
    request_type_description = '',
    type = '',
    no = 0,
    name = '',
    description = '',
    menu_section_id = 0,
    menu_section_name = '',
    menu_category_id = 0,
    menu_category_name = '',
    menu_item_id = 0,
    menu_item_name = '',
    quantity = 0,
    unit_price = 0,
    currency_code = '',
    amount = 0,
    request_time = '',
    unit_of_measure = '',
    child_ages = '',
    date = '',
    gift_expire_date = new Date(),
    create_voucher_no = false,
    voucher_no = 'string',
    is_redeemed = false,
    redeemed_user_id = 0,
    redeemed_at = new Date()
  ) {
    this.id = id;
    this.request_header_id = request_header_id;
    this.line_no = line_no;
    this.request_type = request_type;
    this.request_type_id = request_type_id;
    this.request_type_name = request_type_name;
    this.request_type_description = request_type_description;
    this.type = type;
    this.no = no;
    this.name = name;
    this.description = description;
    this.menu_section_id = menu_section_id;
    this.menu_section_name = menu_section_name;
    this.menu_category_id = menu_category_id;
    this.menu_category_name = menu_category_name;
    this.menu_item_id = menu_item_id;
    this.menu_item_name = menu_item_name;
    this.quantity = quantity;
    this.unit_price = unit_price;
    this.currency_code = currency_code;
    this.amount = amount;
    this.request_time = request_time;
    this.unit_of_measure = unit_of_measure;
    this.child_ages = child_ages;
    this.date = date;
    this.gift_expire_date = gift_expire_date;
    this.create_voucher_no = create_voucher_no;
    this.voucher_no = voucher_no;
    this.is_redeemed = is_redeemed;
    this.redeemed_user_id = redeemed_user_id;
    this.redeemed_at = redeemed_at;

  }

}
